import { lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";

const Dashboard = lazy(() => import("sohum/dashboard"));
const SignUpCover = lazy(() => import("layouts/authentication/sign-in/cover"));
const SignUpOTP = lazy(() => import("layouts/authentication/sign-in/OTP"));
const Compare = lazy(() => import("sohum/compare"));
const Catalog = lazy(() => import("sohum/catalog"));
const MasterData = lazy(() => import("sohum/masterData"));
const Pricing = lazy(() => import("sohum/pricing"));
const Performance = lazy(() => import("sohum/performance"));
const Pivot = lazy(() => import("sohum/pivot"));

const NavBarRoutes = {
  petermiller: [
    {
      name: "Login",
      route: "/login",
      key: "login",
      component: <SignUpCover />,
    },
    {
      name: "OTP",
      route: "/otp",
      key: "otp",
      component: <SignUpOTP />,
    },
    {
      name: "Pricing",
      route: "/pricing",
      key: "pricing",
      component: (
        <ProtectedRoute>
          <Pricing />
        </ProtectedRoute>
      ),
    },
    {
      name: "Performance",
      route: "/performance",
      key: "performance",
      component: (
        <ProtectedRoute>
          <Performance />
        </ProtectedRoute>
      ),
    },
    {
      name: "Catalog",
      route: "/catalog",
      key: "catalog",
      component: (
        <ProtectedRoute>
          <Catalog />
        </ProtectedRoute>
      ),
    },
    {
      name: "Master Data",
      route: "/masterData",
      key: "masterData",
      component: (
        <ProtectedRoute>
          <MasterData />
        </ProtectedRoute>
      ),
    },
    {
      name: "Dashboard",
      route: "/dashboard",
      key: "dashboard",
      component: (
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      ),
    },
    {
      name: "Compare",
      route: "/compare",
      key: "compare",
      component: (
        <ProtectedRoute>
          <Compare />
        </ProtectedRoute>
      ),
    },
    {
      name: "Pivot",
      route: "/pivot",
      key: "pivot",
      component: (
        <ProtectedRoute>
          <Pivot />
        </ProtectedRoute>
      ),
    },
  ],
};

export default NavBarRoutes.petermiller;
